 // Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { connect } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import { bindActionCreators } from "redux";
import { elementContains, Spinner, SpinnerSize } from "office-ui-fabric-react";
import IUserModelActions, * as userModelActions from "../../../../redux/actions/modalActions";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import { IProject, IAuthenticationState, IApplicationState, IConnection, IAzureFields, LabelType } from "../../../../models/applicationState";
import HeaderComponent from "../header/header";
import size from "lodash/size";
import IFilesUploadingAction, * as filesUploadingAction from "../../../../redux/actions/filesUploadingAction";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import MyModels from "../myModels/myModels";
import axios from "axios";
import { accessToken ,docMgt_UpdateStatus,headers } from "../../../../common/api-config";
import base64 from "base-64";
import { toast } from "react-toastify";
import Select from "react-select";
import filterIcon from "../../../../assets/images/Filter-icon.svg";
import { getDarkTheme, getPrimaryBlueTheme } from "../../../../common/themes";
import moment from "moment";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
  Customizer,
  Dialog,
  DialogFooter,
  DialogType,
  ICustomizations,
  ITheme,
  PrimaryButton,
} from "@fluentui/react";

import { Multiselect } from 'multiselect-react-dropdown';

// import "../invoiceManagement/invoicemanagement.scss";
// import Modal from "react-bootstrap/esm/Modal";
// import Button from "react-bootstrap/esm/Button";

export interface IDocumentManagementProps extends RouteComponentProps, React.Props<DocumentManagement> {
  userModelActions: IUserModelActions;
  loggedInUser: IAuthenticationState;
  userOperationsActions: IUserOperationsActions;
  filesUploadingAction: IFilesUploadingAction;
  actions: IProjectActions;
  project: IProject;
  recentProjects: IProject[];
  path: object;
  projectActions: IProjectActions;
  userModels: any;
}

export interface IDocumentManagementState {

  userId: string;
  connection: IConnection;
  myModels: any;
  loadModal: boolean;
  showDate: boolean;
  allData: any;
  loaderText: string;
  loadingProjects: boolean;
  selectedFilter: any;
  invoiceWithOrwithoutPO: String;
  selectedRecords: any;
  fromDate: any;
  toDate: any;
  loadProcess: boolean;
  appliedFilters: any;
  companyFilter: boolean;
  vendorFilter: boolean;
  irFilter: boolean;
  searchText: null;
  headers: any;
  AI_models: any;
  show: boolean;
  setShow: boolean;
  selectedRow: any;
  currentPage:number;
  displayCountPerPage:number;
  currentLength:number;
  country:any;
  selectedcountry:any;
  selectedTFcountry:any;
  statusList:any;
  AllstatusList:any;
  selectedStatus:any;  
  selectedTFStatus:any;  
  displayAdvancedPopup:boolean;
  advancedFilters:any;  
  af_PO:any;
  af_Order:any;
  af_Ship:any;
  af_Country:any;
  af_Status:any;
  af_FromDate:any;
  af_ToDate:any;
  af_Plant:any;
  af_SO:any;
  af_CEmail:any;
  displayCountrydd:boolean;
  displayStatusdd:boolean;
  updatestatusSelVal:any;
  SortEmail:any;
  SortDate:any;
  allFilData: any;
  selectAllReqId:any;
  hidePopUp:any;
  hideSuccPopUp:any;
  checkedId:any;
  af_StatusList:any;
}

function mapDispatchToProps(dispatch) {
  return {
    userModelActions: bindActionCreators(userModelActions, dispatch),
    userOperationsActions: bindActionCreators(userOperationsActions, dispatch),
    filesUploadingAction: bindActionCreators(filesUploadingAction, dispatch),
    actions: bindActionCreators(projectActions, dispatch),
  };
}

function mapStateToProps(state: IApplicationState) {
  return {
    loggedInUser: state.loggedInUser,
  };
}
@connect(mapStateToProps, mapDispatchToProps)

export default class DocumentManagement

  extends React.Component<IDocumentManagementProps, IDocumentManagementState> {


  greenCheck: boolean;
  redCheck: boolean;
  yellowCheck: boolean;

  public state: IDocumentManagementState = {
    userId: null,
    connection: { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} },
    myModels: [],
    loadModal: false,
    showDate: false,
    loadProcess: false,
    allData: [],
    loaderText: "Loading files to preview",
    loadingProjects: false,
    selectedFilter: '',
    invoiceWithOrwithoutPO: '',
    selectedRecords: [],
    fromDate: '',
    toDate: '',
    appliedFilters: [],
    companyFilter: false,
    vendorFilter: false,
    irFilter: false,
    searchText: null,
    headers: [],
    AI_models: [],
    show: false,
    setShow: false,
    selectedRow: {},
    currentPage: 1,
    displayCountPerPage:10,
    currentLength:20,
    country:[],
    selectedcountry:[],
    selectedTFcountry:[],
    statusList:[],
    AllstatusList:[],
    selectedStatus:[],
    selectedTFStatus:[],
    displayAdvancedPopup:false,
    advancedFilters:[],
    af_PO:'',
    af_Order:'',
    af_Ship:'',
    af_Country:'',
    af_Status:'',
    af_FromDate:'',
    af_ToDate:'',
    af_Plant:'', 
    af_SO:'',
    af_CEmail:'', 
    displayCountrydd:false,
  displayStatusdd:false  ,
  updatestatusSelVal:[],
  SortEmail:'ASC',
  SortDate:'ASC',
  allFilData:[],
  selectAllReqId:'',
  hidePopUp:true,
  hideSuccPopUp:true,
  checkedId:"",
  af_StatusList:[],
  };
  records = [];
  node : any;
  nodeDropdown:any;
  nodeCountryDropdown:any;
  green_selected: boolean;
  yellow_selected: boolean;
  red_selected: boolean;
  allDettsils: any
  handleClose = () => {
    this.setState({ show: false })
  };
  constructor(props) {
    super(props);
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate()
    let currentDate = year + "-" + month + "-" + day
    this.setState({ fromDate: currentDate })
    this.outClick = this.outClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }
  outClick(){
      if (!this.state.displayAdvancedPopup) {
        // attach/remove event handler
        document.addEventListener('click', this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', this.handleOutsideClick, false);
      }
  
      this.setState(prevState => ({
         displayAdvancedPopup: !prevState.displayAdvancedPopup,
      }));
  }

  handleOutsideClick(e) {
    if(this.node){
      if (this.node.contains(e.target)) {
        return;
      }
     if(this.nodeDropdown){
        if(this.nodeDropdown.props){
          if(this.nodeDropdown.props.value){
            if(this.nodeDropdown.props.value.value == e.target.textContent || e.target.textContent == "No options"){
              return;
            }
          }
        }
      }
      if(this.nodeCountryDropdown){
        if(this.nodeCountryDropdown.props){
          if(this.nodeCountryDropdown.props.value){
            if(this.nodeCountryDropdown.props.value.value == e.target.textContent || e.target.textContent == "No options"){
              return;
            }
          }
        }
      }
       
      
            if(e.target.className == "icon_cancel closeIcon"){
              return;
            }
    }
    this.outClick();
  }
  handleClick(event) {
    //debugger;
    if (event.target.nodeName === 'INPUT' && event.target.parentElement.nodeName === 'TH') {
      let tbody = document.getElementsByTagName('tbody')[0]
      let checks = tbody.getElementsByTagName('input')
      if (event.target.checked) {
        for (let i = 0; i < checks.length; i++) {
          checks[i]['checked'] = true;
        }
        this.setState({ selectedRecords: this.state.myModels })
      }
      else {
        for (let i = 0; i < checks.length; i++) {
          checks[i]['checked'] = false;
        }
        this.setState({ selectedRecords: [] })

      }
    }

  }

  handleClickNew(event,id){
    this.setState({
      selectAllReqId:id,
      hideSuccPopUp:true
    })
    let p = [...this.state.myModels]
    if (event.target.checked) {
      Object.keys(p).map(key=>{
        if(p[key]["RequestDetailsID"] == id){
          p[key]["isChecked"] = true
        }
      })
      this.setState({ selectedRecords: this.state.myModels })
    }
    else{
      Object.keys(p).map(key=>{
        if(p[key]["RequestDetailsID"] == id){
          p[key]["isChecked"] = false
        }
      })
    this.setState({ selectedRecords: [] })
    }
    
    this.setState({
      myModels:p
    })
  }

  handlePageClick(event) {
    this.setState({
      currentPage: Number(event.target.id)
    });
  }

  handleNextClick(e)
  {
    let currentPage = this.state.currentPage;
    const lastpage = Math.ceil(this.state.myModels.length / this.state.displayCountPerPage);
    if(currentPage===lastpage)
    {
       
    }
    else
    {
    currentPage =  currentPage+1;
    }
    
    this.setState({
      currentPage: currentPage
    });
  }
  handlePreviousClick(e)
  {
    let currentPage = this.state.currentPage;
    if(currentPage===1)
    {
       
    }
    else
    {
    currentPage = currentPage-1;
    }
    
    this.setState({
      currentPage: currentPage
    });
  }

  validateMultiple(model,e,index){
    //debugger;
    if(e.target.checked){
      let p = [...this.state.myModels];
      p[index]["isChecked"] = true;
      this.setState({
        myModels : p
      },()=>{
        let found = false , id = ""
      Object.keys(this.state.myModels).map(key=>{
        if(this.state.myModels[key]["RequestDetailsID"] == model["RequestDetailsID"]){
          if(this.state.myModels[key]["isChecked"]!=true){
              found = true
              id = this.state.myModels[key]["RequestDetailsID"]
            }
        }
      })
      if(found){
        this.setState({
          hidePopUp:false,
          checkedId:id
        })
        this.handleSingleCheck(model,true,index)
      }
      else{
        this.handleSingleCheck(model,true,index)
      }
      })
    }
    else{
      let p = [...this.state.myModels];
      p[index]["isChecked"] = false;
      this.setState({
        myModels : p
      })
      this.handleSingleCheck(model,false,index);
    }
    
    //uncheck the selected status
    this.setState({ updatestatusSelVal: [] });
    
    
     
  }

   updateStatusAll(){
    let p = [...this.state.myModels]
      Object.keys(p).map(key=>{
        if(p[key]["RequestDetailsID"] == this.state.checkedId){
          this.handleSingleCheck(p[key],true,'')
          p[key]["isChecked"] = true
        }
      })
      this.setState({ myModels:p,hidePopUp:true })
  }

  handleSingleCheck(model,status,index) {
   
   let records = this.state.selectedRecords;
   // this.setState({ selectedRecords: this.records })
    //debugger;
    if(status)
    {     
      
      //
      let present = false;
      for (var i = 0; i < records.length; i++) {
        if (records[i].RowKey == model.RowKey) {
          present = true;          
          break;
        }
      }
      if (!present) {
        records.push(model)
      }      
      //
      
    }
    else
    {
      //
      let present = false;
      let presentindex=0;
      for (var i = 0; i < records.length; i++) {
        if (records[i].RowKey == model.RowKey) {  
          presentindex=i;
          present = true; 
          break;
                }
      }      
      if (present) {
        records.splice(i, 1);
      }
      //     
      
    }
    /*
    if (this.records.length > 0) {
      let present = false;
      for (var i = 0; i < this.records.length; i++) {
        if (this.records[i].Filename == model.Filename) {
          present = true;
          this.records.splice(i, 1);
          break;
        }
      }

      if (!present) {
        this.records.push(model)
      }
    } else {
      this.records.push(model)
    }
    */
    this.setState({ selectedRecords: records });

  }

  public async componentDidMount() {
    const user = this.props.loggedInUser;
    const userId = user.user.oid;
    await this.setState({ loadModal: true, userId });
    localStorage.removeItem("lastVisttedtestAssetId");
    localStorage.removeItem("filesLength");
    localStorage.removeItem("testFilesLengthFromTest");
    localStorage.removeItem("filesLengthFromModel");
    this.setState({ loadModal: true });
    let isBackClick = localStorage.getItem("DocMgtBack");
   
    let modelData;
 
    
    if(isBackClick=== "Y")
    {
    //  // let selectedFilters = JSON.parse(localStorage.getItem("selectedDocMgtFilters"));
     
    //   modelData = await this.props.userOperationsActions.documentMangement();
                             
    //   // modelData = JSON.parse(localStorage.getItem("DocMgtModelData"));

    let selectedFilters = JSON.parse(localStorage.getItem("selectedDocMgtFilters"));
     let startDate = selectedFilters.af_FromDate?selectedFilters.af_FromDate:"";
     let endDate = selectedFilters.af_ToDate? selectedFilters.af_ToDate:"";
     if(startDate!="")
      {
        //modelData = await this.props.userOperationsActions.documentMangementByDate(moment(startDate).startOf('day').format("MM/DD/YYYY[T]HH:mm:ss"),moment(endDate).endOf('day').format("MM/DD/YYYY[T]HH:mm:ss"));
    
        modelData = await this.props.userOperationsActions.documentMangementByDate(moment(startDate).startOf('day').format("YYYY-MM-DD[T]HH:mm:ss"),moment(endDate).endOf('day').format("YYYY-MM-DD[T]HH:mm:ss"));
      }
      else{
        modelData = await this.props.userOperationsActions.documentMangement();
      }
       
    }
    else
    {
       modelData = await this.props.userOperationsActions.documentMangement();
      
    }
    //debugger;
    //modelData = modelData.sort(x=>x.Timestamp);
    
    localStorage.setItem("DocMgtBack", "N");
    
    
   
    let firstRow = modelData[0];
    this.allDettsils = modelData;
    let keys = []
    let finalKeys = [];
    if (this.allDettsils.length) {
      keys = Object.keys(firstRow);
      keys.forEach((element, i) => {
        if (element == 'Tagsinfo' || element == 'url') {
          keys.splice(i, 1)
        }
      })
    }

    let Aimodels = []
    this.allDettsils.forEach(element => {
      if (Aimodels.length > 0) {
        let present = false;
        Aimodels.forEach(data => {
          if (data.value == element.project_name) {
            present = true;
          }
        })
        if (!present) {
          Aimodels.push({ value: element.project_name, label: element.project_name })
        }
      } else {
        Aimodels.push({ value: element.project_name, label: element.project_name })
      }
    });
    // contry
    let country=[];
    /*
    //ship to start
    let shiptoend=[];
    this.allDettsils.forEach(element => {
      if(shiptoend.length>450)
      {
        console.log(shiptoend.length);
        console.log("==>"+JSON.stringify(element));
      }
      shiptoend.push(element.ShipTo.trim());
     
    });
    
    //ship to end
    */
    //
    //debugger;
    /*
    this.allDettsils.forEach(element => {
      if (country.length > 0) {
        let present = false;
        country.forEach(data => {
          if (data.value == element.Country) {
            present = true;
          }
        })
        if (!present) {
          country.push({ value: element.Country, label: element.Country })
        }
      } else {
        country.push({ value: element.Country, label: element.Country })
      }
    });
    //
    if (country.length > 0) {
      
     
    }
    */
     country.push({ value: "ca", label: "ca" });
      country.push({ value: "us", label: "us" });
      country.push({ value: "All", label: "All" });
    
    
    let statusList=[];
    //
    this.allDettsils.forEach(element => {
      if (statusList.length > 0) {
        let present = false;
        statusList.forEach(data => {
        if (data.value == element.Status) {
          present = true;
        }
        });
        if(element.Status.trim()!="")
        {
        if (!present) {
        statusList.push({ value: element.Status, label: element.Status })
        }
      } 
    }
    else
    {
      //
      if(element.Status!="")
      {
      
      statusList.push({ value: element.Status, label: element.Status })
      }
      //
    }
      });
    //
    
    if (statusList.length > 0) {
      statusList.push({ value: "All", label: "All" })
    }
    //
    this.setState({ loadModal: false, myModels: modelData, allFilData:modelData, allData: modelData, headers: keys, AI_models: Aimodels,country: country,statusList:statusList,AllstatusList:statusList},()=>{
      let result = this.state.myModels;
      result.sort((a, b) => {
        if (isNaN(new Date(b["Email_Sent_Date"]).getTime())&&isNaN(new Date(a["Email_Sent_Date"]).getTime())) { 
          return (b["Email_Sent_Date"]!=""?(moment(b["Email_Sent_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0)
          - (a["Email_Sent_Date"]!=""?(moment(a["Email_Sent_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0);
        }
        else{
          return (b["Email_Sent_Date"]!=""?(new Date(b["Email_Sent_Date"]).getTime()):0)
          - (a["Email_Sent_Date"]!=""?(new Date(a["Email_Sent_Date"]).getTime()):0);
        }
       });
     this.setState({
       myModels:result
     })
    });
    
    if(isBackClick=== "Y")
    {
     
     
      //SET Filters
      let selectedFilters = JSON.parse(localStorage.getItem("selectedDocMgtFilters"));
     /*
      this.setState({ selectedcountry: selectedFilters.selectedcountry,
                      selectedStatus:selectedFilters.selectedStatus,
                            fromDate:selectedFilters.fromDate,
                             toDate:selectedFilters.fromDate!==""?selectedFilters.toDate:"", 
                             searchText:selectedFilters.searchText,
                            });*/
                            
                       /*     let selectedFilters={      
                              af_Country:this.state.af_Country,
                              af_Status:this.state.af_Status,
                              fromDate:this.state.af_FromDate,
                              af_ToDate:this.state.af_ToDate,      
                              af_Order:this.state.af_Order,
                              af_PO:this.state.af_PO,
                              af_Plant:this.state.af_Plant,
                              af_Ship:this.state.af_Ship, 
                              searchText:this.state.searchText,
                            };
                            */
                            
                            this.setState({ af_Country: selectedFilters.af_Country,
                              af_Status: selectedFilters.af_Status,
                              af_FromDate: selectedFilters.af_FromDate,
                              af_ToDate: selectedFilters.af_ToDate,
                              af_Order: selectedFilters.af_Order,
                              af_PO: selectedFilters.af_PO,
                              af_Plant: selectedFilters.af_Plant,                             
                              af_Ship:selectedFilters.af_Ship,     
                              af_SO:selectedFilters.af_SO, 
                              af_CEmail:selectedFilters.af_CEmail,                            
                              searchText:selectedFilters.searchText,                             
                              
                            
 displayCountrydd:selectedFilters.displayCountrydd,
 displayStatusdd:selectedFilters.displayStatusdd, 
  
selectedTFStatus:selectedFilters.selectedTFStatus,
selectedTFcountry:selectedFilters.selectedTFcountry,
                              
                              
                              
                                    });  
                            
                                    if(selectedFilters.af_Country!="")
                                    {
                                      this.setState({ selectedcountry: [{ value: selectedFilters.af_Country, 
                                                                          label: selectedFilters.af_Country }] });
                                    }
                                    else
                                    {
                                      this.setState({ selectedcountry: [] });
                                    }
                                    
                                    if(selectedFilters.af_Status!="")
                                    {
                                      this.setState({ selectedStatus: [{ value: selectedFilters.af_Status, 
                                                                          label: selectedFilters.af_Status }] });
                                    }
                                    else
                                    {
                                      this.setState({ selectedStatus: [] });
                                    }
                                    
                                    
                                   
                             
                            let startDate = selectedFilters.af_FromDate?selectedFilters.af_FromDate:"";
                            
                            let endDate = selectedFilters.af_ToDate? selectedFilters.af_ToDate:"";
                             
        /*   this.getDocMgtDatabydateCountryStatus(startDate,endDate,          
             
            selectedFilters.selectedcountry?selectedFilters.selectedcountry:"",
            selectedFilters.selectedStatus?selectedFilters.selectedStatus:"",            
            selectedFilters.searchText?selectedFilters.searchText:"");
            */
            
            this.getDocMgtDatabydateCountryStatus_af(startDate,endDate,          
             
              selectedFilters.af_Country?selectedFilters.af_Country:"",
              selectedFilters.af_Status?selectedFilters.af_Status:"",
                 
              selectedFilters.af_Order?selectedFilters.af_Order:"",
              selectedFilters.af_PO?selectedFilters.af_PO:"",   
              
              selectedFilters.af_Country?selectedFilters.af_Plant:"",
              selectedFilters.af_Status?selectedFilters.af_Ship:"",   
              
              selectedFilters.af_SO?selectedFilters.af_SO:"",
              selectedFilters.af_CEmail?selectedFilters.af_CEmail:"",   
              
              selectedFilters.searchText?selectedFilters.searchText:"",
              
              selectedFilters.selectedTFStatus,
              selectedFilters.selectedTFcountry,
              modelData
              
              
              );
              
              
                                                        
                             
                             //get data and apply filters
                          //   result = result.filter(element => element.Country == event.value);               
                             
                             
                             
      
    }    
    else
    {
      localStorage.setItem("DocMgtBack", "N");
    }
  }

  public searchSpace = (e) => {
    const keyword = e.target.value;
    this.setState({ searchText: keyword });
    if (keyword === "") {
      this.setState({ myModels: this.state.allData });
      this.tableDataShow();
    } else {
      let result = this.state.allData;
     // result = result.filter(element => element.Filename.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Customer.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Milestone.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Primary_Skill.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Project.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Ref.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Sequence.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Task.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Work_Order.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Zone.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.project_name.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.status.trim().toUpperCase().startsWith(keyword.toUpperCase()));
     //result = result.filter(element => element.RequestDetailsID.trim().toUpperCase().startsWith(keyword.toUpperCase()));
     
    
     result = result.filter(element => element.RequestDetailsID.trim().toUpperCase().startsWith(keyword.toUpperCase()) ||
      element.SONumber.trim().toUpperCase().startsWith(keyword.toUpperCase()) ||
      element.PO.trim().toUpperCase().startsWith(keyword.toUpperCase()) ||
      element.OrderType.trim().toUpperCase().startsWith(keyword.toUpperCase()) ||
      element.Customer_email_address.trim().toUpperCase().startsWith(keyword.toUpperCase()) ||
      element.ShipTo.toString().trim().toUpperCase().startsWith(keyword.toUpperCase()) ||      
      element.Plant.trim().toUpperCase().startsWith(keyword.toUpperCase()) );
      /*
      
      result = result.filter(element =>
        
      
      element.ShipTo.trim().toUpperCase().startsWith(keyword.toUpperCase()) );*/
      
     this.setState({ myModels: result });

    }
  }
  
  
  private getTFStatus = (event) => {
    //debugger;
    console.log(event)
    let result = this.state.allData;
   
    if (event != null) {
      
      let coun = this.state.selectedTFcountry;
      let counval = coun.value?coun.value:"";
      
      if(counval!="")
      {
        if(event.value ==="All")
        {
          result = result;
        }
        else
        {
          result = result.filter(element => ( element.Status == event.value ));
        }
    
     //result = result.filter(element => ( element.Country == counval ));     
     //     
     if (counval === "All") {
      result = result;
    }
    else
    {
      result = result.filter(element => ( element.Country == counval));
    }
     //
      
      }
      else
      {
        if(event.value==="All")
        {
          result = result ; //.filter(element => ( element.Status == event.value));
        }
        else
        {
          result = result.filter(element => ( element.Status == event.value));
        }
       
      }
      
    //  result = result.filter(element => element.Status == event.value);
      this.setState({ myModels: result })
      this.setState({ selectedTFStatus: event });
    
      
    } else {
      this.setState({ myModels: result })
      this.setState({ selectedTFStatus: [] });
     
      
    }
  }
  
  private getStatus = (event) => {
    console.log(event)
    let result = this.state.allData;
   
    if (event != null) {
     // result = result.filter(element => element.Status == event.value);
    //  this.setState({ myModels: result })
      this.setState({ selectedStatus: event });
      this.setState({af_Status:event.value});
      
    } else {
    //  this.setState({ myModels: result })
      this.setState({ selectedStatus: [] });
      this.setState({af_Status:""});
      
    }
  }
  
  private getType = (event) => {
    console.log(event)
    let result = this.state.allData;

    if (event != null) {
    //  result = result.filter(element => element.project_name == event.value);
    //  this.setState({ myModels: result })
      this.setState({ appliedFilters: event });
    } else {
      this.setState({ myModels: result })
      this.setState({ appliedFilters: [] });
    }
  }
  
  private getTFCountry = (event) => {
    console.log(event);
    let result = this.state.allData;

    if (event != null) {
      
      let status = this.state.selectedTFStatus;
      let statusval = status.value?status.value:"";
      if(statusval!="")
      {
        
        if(event.value!="All")
        {
     result = result.filter(element => ( element.Country == event.value ));
        }
        else
        {
          result = result;
        }
         
     
     if (statusval === "All") {
      result = result;
    }
    else
    {
      result = result.filter(element => ( element.Status == statusval )); 
    }
     
    //result = result.filter(element => ( element.Status == statusval )); 
    
    }      else
      {
        
        
        //
        if (event.value === "All") {
          result = result;
        }
        else
        {
          result = result.filter(element => ( element.Country == event.value));
        }
        //
        
       // result = result.filter(element => ( element.Country == event.value));
        
        
        
      }
      
      this.setState({ myModels: result });
      this.setState({ selectedTFcountry: event });
      
      
    } else {
     this.setState({ myModels: result });
      this.setState({ selectedTFcountry: [] });
    
    }
    
    
    
  }
  
  private getCountry = (event) => {
    console.log(event);
    //let result = this.state.allData;

    if (event != null) {
     // result = result.filter(element => element.Country == event.value);
     // this.setState({ myModels: result });
      this.setState({ selectedcountry: event });
      
      this.setState({ af_Country: event.value });
    } else {
     // this.setState({ myModels: result });
      this.setState({ selectedcountry: [] });
      this.setState({ af_Country: "" });
    }
  }


  public handleShow = async (model) => {
    console.log(model)

    this.setState({ show: true, selectedRow: model })
  }

  green(){
    this.green_selected=!this.green_selected;
  this.yellow_selected=false;
  this.red_selected=false;
    if(this.green_selected){
      const result = this.state.allData;
      this.setState({
       myModels: []
      });
    }else{
      this.setState({
        myModels: this.state.allData
    })}
  }
  yellow(){ 
    this.green_selected=false;
    this.yellow_selected=!this.yellow_selected;
    this.red_selected=false;
    if(this.yellow_selected){
      const result = this.state.allData;
      this.setState({
       myModels: result
      });
    }else{
      this.setState({
        myModels: this.state.allData
    })}

   

  }
  red(){
    this.green_selected=false;
    this.yellow_selected=false;
    this.red_selected=!this.red_selected;
    if(this.red_selected){
    this.setState({
      myModels: []
     });}else{
      this.setState({
        myModels: this.state.allData
    })
     }
   
    

  }

  private fromDateChange = (event) => {
    
   
    this.setState({ fromDate: event.target.value });
    if (this.state.toDate != '') {
      var startDate = new Date(event.target.value);
      var endDate = new Date(this.state.toDate);
      console.log(event.target.value);
      console.log(startDate);
      console.log(endDate);
      /*
      var resultProductData = this.state.allData.filter(a => {
        let date1 = a.Timestamp.split(" ")[0]
        console.log(date1)
        var date = new Date(date1);
        console.log(date)
        return (date >= startDate && date <= endDate);
      });
      this.setState({ myModels: resultProductData });
      console.log(resultProductData);
      */
     
      if(startDate <= endDate)
      {
     // this.getDocMgtDatabydate(event.target.value,this.state.toDate );
      }
      else
      {
        toast.warn("From date should be less than To date", { position: toast.POSITION.TOP_CENTER });
      }
      
    }
    else
    {
    
      //only from date exists --new condition
      //this.getDocMgtDatabydate(event.target.value,this.state.toDate );
      const today = moment().format("YYYY-MM-DD");
      //this.getDocMgtDatabydate(event.target.value,today );
      
    }
  }

  private toDateChange = (event) => {
    this.setState({ toDate: event.target.value });
    if (this.state.fromDate != '') {
      console.log(this.state.fromDate,"this.state.fromDate")
      var startDate = new Date(this.state.fromDate);
      var endDate = new Date(event.target.value);
      console.log(event.target.value);
      console.log(startDate);
      console.log(endDate);
      
      
      if(startDate <= endDate)
      {
      // this.getDocMgtDatabydate(this.state.fromDate, event.target.value);

      }
      else
      {
        toast.warn("From date should be less than To date", { position: toast.POSITION.TOP_CENTER });
      }
     // this.getDocMgtDatabydate(this.state.fromDate, event.target.value);
      /*
      var resultProductData = this.state.allData.filter(a => {
        console.log(a.Timestamp,"timeStamp")
        let date1 = a.Timestamp.split(" ")[0]
        console.log(date1)
        var date = new Date(date1);
        console.log(date)
        return (date >= startDate && date <= endDate);
      });
      this.setState({ myModels: resultProductData })
     
      
      console.log(resultProductData)
       */
    } else {
      alert("Please select from date");
    }
  }
/*
  public getDocMgtDatabydate =async (fromDate:string, toDate:string)=>
  {
  
    await this.setState({ loadingProjects: true});
  //  this.setState({ loadModal: true });
    toast.success("Fetching the Records", { position: toast.POSITION.TOP_CENTER });
    const modelData = await this.props.userOperationsActions.documentMangementByDate(fromDate,toDate);
    let firstRow = modelData[0];
    this.allDettsils = modelData;
    let keys = [];
    let finalKeys = [];
    toast.success("Number of Records Found:"+this.allDettsils.length, { position: toast.POSITION.TOP_CENTER });
    if (this.allDettsils.length) {
      keys = Object.keys(firstRow);
      keys.forEach((element, i) => {
        if (element == 'Tagsinfo' || element == 'url') {
          keys.splice(i, 1)
        }
      })
    }

    console.log(keys)
    let Aimodels = []
    this.allDettsils.forEach(element => {
      if (Aimodels.length > 0) {
        let present = false;
        Aimodels.forEach(data => {
          if (data.value == element.project_name) {
            present = true;
          }
        })
        if (!present) {
          Aimodels.push({ value: element.project_name, label: element.project_name })
        }
      } else {
        Aimodels.push({ value: element.project_name, label: element.project_name })
      }
    });
    // contry
    let country=[];
    
    //
    this.allDettsils.forEach(element => {
      if (country.length > 0) {
        let present = false;
        country.forEach(data => {
          if (data.value == element.Country) {
            present = true;
          }
        })
        if (!present) {
          country.push({ value: element.Country, label: element.Country })
        }
      } else {
        country.push({ value: element.Country, label: element.Country })
      }
    });
    //
    
    
    
    let statusList=[];
    //
    this.allDettsils.forEach(element => {
      if (statusList.length > 0) {
        let present = false;
        statusList.forEach(data => {
        if (data.value == element.Status) {
          present = true;
        }
        });
        if (!present) {
        statusList.push({ value: element.Status, label: element.Status })
        }
      } else {
        statusList.push({ value: element.Status, label: element.Status })
      }
      });
    //
    //
    await this.setState({ loadingProjects: false});
    this.setState({ myModels: modelData, allData: modelData, headers: keys, AI_models: Aimodels,country: country,statusList:statusList});
    this.setState({ fromDate: fromDate, toDate: toDate });
    //
  }
  */
  
  public getDocMgtDatabydate_af =async (fromDate:string, toDate:string)=>
  {
    //debugger;
    //
    await this.setState({ loadingProjects: true});
    let modelData;
  //  this.setState({ loadModal: true });
   // toast.success("Fetching the Records", { position: toast.POSITION.TOP_CENTER });
    
    console.log("Fetching the Records");
    if ((fromDate!= "")&&  (toDate!= "")) {
  //   modelData = await this.props.userOperationsActions.documentMangementByDate(moment(fromDate).startOf('day').format("MM/DD/YYYY[T]HH:mm:ss"),moment(toDate).endOf('day').format("MM/DD/YYYY[T]HH:mm:ss"));
     modelData = await this.props.userOperationsActions.documentMangementByDate(moment(fromDate).startOf('day').format("YYYY-MM-DD[T]HH:mm:ss"),moment(toDate).endOf('day').format("YYYY-MM-DD[T]HH:mm:ss"));
     this.setState({ allData: modelData});
    }
    else
    {
      modelData = this.state.allData;
    }
    //debugger;
  //  let firstRow = modelData[0];   
    if (this.state.af_Country!= "" && this.state.af_Country!= "All" ) {
      modelData = modelData.filter(element => element.Country.toLowerCase().startsWith(this.state.af_Country.toLowerCase()));    
    }    
    /* 
    if (this.state.af_Status!= "" && this.state.af_Status!= "All") {
      modelData = modelData.filter(element => element.Status.toLowerCase().startsWith(this.state.af_Status.toLowerCase()));  
    } 
    */
    //MULTI SELECT START
    let selectedstatusfilter = this.state.af_StatusList?this.state.af_StatusList:[];
   /*selectedstatusfilter.foreach( nstatus=>
      {
        modelData = modelData.filter(element => element.Status.toLowerCase().startsWith(nstatus.value.toLowerCase()));  
      });*/
      if(size(selectedstatusfilter)>0)
      {
        let allfound=false;
         let nmodelData=[];
         let fmodelData=[];
      for (const [i, nstatus] of selectedstatusfilter.entries()) {
           nmodelData=[];
           nmodelData = modelData.filter(element => element.Status.toLowerCase()===nstatus.value.toLowerCase());  
           
           if(nstatus.value=== "All")
           {
            allfound=true;
           }
           if(size(nmodelData)>0)
           {
                fmodelData = [...fmodelData,...nmodelData];
           }
      
          }
      
        if(size(selectedstatusfilter)>0)
        {
          if(allfound)
          {
            }
            else
            {
          modelData=fmodelData;
            }
        }
        
      }
    
    //MULTI SELECT END
    
    
    
    if (this.state.af_PO!= "") {
      modelData = modelData.filter(element => element.PO.toLowerCase().startsWith(this.state.af_PO.toLowerCase()));    
    } 
    
    if (this.state.af_Plant!= "") {
      modelData = modelData.filter(element => element.Plant.toLowerCase().startsWith(this.state.af_Plant.toLowerCase()));        
    } 
    if (this.state.af_Ship!= "") {
      modelData = modelData.filter(element => element.ShipTo.toLowerCase().startsWith(this.state.af_Ship.toLowerCase()));       
    } 
    
    if (this.state.af_Order!= "") {
      modelData = modelData.filter(element => element.OrderType.toLowerCase().startsWith(this.state.af_Order.toLowerCase()));    
    }  
    
    
    if (this.state.af_SO!= "") {
      modelData = modelData.filter(element => element.SONumber.toLowerCase().startsWith(this.state.af_SO.toLowerCase()));    
    }  
    
    
    
    if (this.state.af_CEmail!= "") {
      modelData = modelData.filter(element => element.Customer_email_address.toLowerCase().indexOf(this.state.af_CEmail.toLowerCase()) !== -1);     
    }  
    
    //apply column filters -start
    
    
    let coun = this.state.selectedTFcountry;
      let counval = coun.value?coun.value:"";     
       
       
      if(counval !== "" && counval !== "All"){     
      modelData = modelData.filter(element => ( element.Country == counval));    
  }
  
  let status = this.state.selectedTFStatus;
  let statusval = status.value?status.value:"";
  
    
  if(statusval !== "" && statusval !== "All"){     
    modelData = modelData.filter(element => ( element.Status == statusval));    
}



    
    //apply column filters -end
    
    
    
    
    
    
    
    this.allDettsils = modelData;  
    console.log("Records count==>"+this.allDettsils.length); 
   // toast.success("Number of Records Found:"+this.allDettsils.length, { position: toast.POSITION.TOP_CENTER });
    //  console.log(keys)
    let Aimodels = []
    this.allDettsils.forEach(element => {
      if (Aimodels.length > 0) {
        let present = false;
        Aimodels.forEach(data => {
          if (data.value == element.project_name) {
            present = true;
          }
        })
        if (!present) {
          Aimodels.push({ value: element.project_name, label: element.project_name })
        }
      } else {
        Aimodels.push({ value: element.project_name, label: element.project_name })
      }
    });

    // contry
    
    
    /*
    let country=[];    
    this.allDettsils.forEach(element => {
      if (country.length > 0) {
        let present = false;
        country.forEach(data => {
          if (data.value == element.Country) {
            present = true;
          }
        })
        if (!present) {
          country.push({ value: element.Country, label: element.Country })
        }
      } else {
        country.push({ value: element.Country, label: element.Country })
      }
    });   
   
    
    
    let statusList=[]; 
    this.allDettsils.forEach(element => {
      if (statusList.length > 0) {
        let present = false;
        statusList.forEach(data => {
        if (data.value == element.Status) {
          present = true;
        }
        });
        if (!present) {
        statusList.push({ value: element.Status, label: element.Status })
        }
      } else {
        statusList.push({ value: element.Status, label: element.Status })
      }
      }); 
       */
      let statusList=[]; 
      this.state.allData.forEach(element => {
        if (statusList.length > 0) {
          let present = false;
          statusList.forEach(data => {
          if (data.value == element.Status) {
            present = true;
          }
          });
          if (!present) {
          statusList.push({ value: element.Status, label: element.Status })
          }
        } else {
          statusList.push({ value: element.Status, label: element.Status })
        }
        }); 
  
        if (statusList.length > 0) {
          statusList.push({ value: "All", label: "All" })
        }
      
    await this.setState({ loadingProjects: false});
    this.setState({ myModels: modelData,    AI_models: Aimodels,statusList,AllstatusList:statusList},()=>{
      let result = this.state.myModels;
      result.sort((a, b) => {
        if (isNaN(new Date(b["Email_Sent_Date"]).getTime())&&isNaN(new Date(a["Email_Sent_Date"]).getTime())) { 
          return (b["Email_Sent_Date"]!=""?(moment(b["Email_Sent_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0)
          - (a["Email_Sent_Date"]!=""?(moment(a["Email_Sent_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0);
        }
        else{
          return (b["Email_Sent_Date"]!=""?(new Date(b["Email_Sent_Date"]).getTime()):0)
          - (a["Email_Sent_Date"]!=""?(new Date(a["Email_Sent_Date"]).getTime()):0);
        }
          // return (b["Email_Sent_Date"]!=""?(new Date(b["Email_Sent_Date"].replace('T', ' ')).getTime()):0) - (a["Email_Sent_Date"]!=""?(new Date(a["Email_Sent_Date"].replace('T', ' ')).getTime()):0) ;
      });
     this.setState({
       myModels:result
     })
    });
    this.setState({ fromDate: fromDate, toDate: toDate });
  
  }
  
  /*
  public getDocMgtDatabydateCountryStatus =async (fromDate:string, toDate:string, scountry:any, status:any,searchText:string)=>
  {
   
    await this.setState({ loadingProjects: true});
  //  this.setState({ loadModal: true });
    toast.success("Fetching the Records", { position: toast.POSITION.TOP_CENTER });
    let  modelData;
    if(fromDate!="")
    {
      modelData = await this.props.userOperationsActions.documentMangementByDate(fromDate,toDate);
    }
    else
    {
      modelData = await this.props.userOperationsActions.documentMangement();
    }
    let firstRow = modelData[0];
    this.allDettsils = modelData;
    let keys = [];
    let finalKeys = [];
    toast.success("Number of Records Found:"+this.allDettsils.length, { position: toast.POSITION.TOP_CENTER });
    if (this.allDettsils.length) {
      keys = Object.keys(firstRow);
      keys.forEach((element, i) => {
        if (element == 'Tagsinfo' || element == 'url') {
          keys.splice(i, 1)
        }
      })
    }

    console.log(keys)
    let Aimodels = [];
    this.allDettsils.forEach(element => {
      if (Aimodels.length > 0) {
        let present = false;
        Aimodels.forEach(data => {
          if (data.value == element.project_name) {
            present = true;
          }
        })
        if (!present) {
          Aimodels.push({ value: element.project_name, label: element.project_name })
        }
      } else {
        Aimodels.push({ value: element.project_name, label: element.project_name })
      }
    });
    // contry
    let country=[];
    
    //
    this.allDettsils.forEach(element => {
      if (country.length > 0) {
        let present = false;
        country.forEach(data => {
          if (data.value == element.Country) {
            present = true;
          }
        })
        if (!present) {
          country.push({ value: element.Country, label: element.Country })
        }
      } else {
        country.push({ value: element.Country, label: element.Country })
      }
    });
    //
    
    
    
    let statusList=[];
    //
    this.allDettsils.forEach(element => {
      if (statusList.length > 0) {
        let present = false;
        statusList.forEach(data => {
        if (data.value == element.Status) {
          present = true;
        }
        });
        if (!present) {
        statusList.push({ value: element.Status, label: element.Status })
        }
      } else {
        statusList.push({ value: element.Status, label: element.Status })
      }
      });
    //
   
    if (scountry!= "") {
      modelData = modelData.filter(element => element.Country == scountry.value);
    
    } 
    
    if (status != "") {
      modelData = modelData.filter(element => element.Status == status.value);    
    } 
    
    if (searchText != "") {
     
      modelData = modelData.filter(element => element.RequestDetailsID.trim().toUpperCase().startsWith(searchText.toUpperCase()) ||
    element.SONumber.trim().toUpperCase().startsWith(searchText.toUpperCase()) ||
    element.PO.trim().toUpperCase().startsWith(searchText.toUpperCase()) ||
    element.OrderType.trim().toUpperCase().startsWith(searchText.toUpperCase()) ||
    element.ShipTo===searchText ||      
    element.Plant.trim().toUpperCase().startsWith(searchText.toUpperCase()) );
    }
    
    //
    await this.setState({ loadingProjects: false});
    this.setState({ myModels: modelData, allData: modelData, headers: keys, AI_models: Aimodels,country: country,statusList:statusList});
    this.setState({ fromDate: fromDate, toDate: toDate });
    //
  }
  */
  
  
  public getDocMgtDatabydateCountryStatus_af =async (fromDate:string, toDate:string,     
    scountry:any, status:any,    order:any,po:any,plant:any,ship:any,so:any, cemail:any,
    searchText:string,selectedTFStatus:any, selectedTFcountry:any,modelData:any
    
    )=>
  {
    await this.setState({ loadingProjects: true});
  //  this.setState({ loadModal: true });
   // toast.success("Fetching the Records", { position: toast.POSITION.TOP_CENTER });
    // let  modelData;
    // if(fromDate!="")
    // {
    //   modelData = await this.props.userOperationsActions.documentMangementByDate(moment(fromDate).startOf('day').format("MM/DD/YYYY[T]HH:mm:ss"),moment(toDate).endOf('day').format("MM/DD/YYYY[T]HH:mm:ss"));
    // }
    // else
    // {
    //   modelData = await this.props.userOperationsActions.documentMangement();
    // }
    modelData.sort((a, b) => {
      if (isNaN(new Date(b["Email_Sent_Date"]).getTime())&&isNaN(new Date(a["Email_Sent_Date"]).getTime())) { 
        return (b["Email_Sent_Date"]!=""?(moment(b["Email_Sent_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0)
        - (a["Email_Sent_Date"]!=""?(moment(a["Email_Sent_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0);
      }
      else{
        return (b["Email_Sent_Date"]!=""?(new Date(b["Email_Sent_Date"]).getTime()):0)
        - (a["Email_Sent_Date"]!=""?(new Date(a["Email_Sent_Date"]).getTime()):0);
      }
     // return (b["Email_Sent_Date"] != "" ? (new Date(b["Email_Sent_Date"].replace('T', ' ')).getTime()) : 0) - (a["Email_Sent_Date"] != "" ? (new Date(a["Email_Sent_Date"].replace('T', ' ')).getTime()) : 0);
    });
    this.setState({
      SortDate: "ASC"
    })
   this.setState({ allData: modelData});
    let firstRow = modelData[0];
    this.allDettsils = modelData;
    let keys = [];
    let finalKeys = [];
   // toast.success("Number of Records Found:"+this.allDettsils.length, { position: toast.POSITION.TOP_CENTER });
    if (this.allDettsils.length) {
      keys = Object.keys(firstRow);
      keys.forEach((element, i) => {
        if (element == 'Tagsinfo' || element == 'url') {
          keys.splice(i, 1)
        }
      })
    }

    console.log(keys)
    let Aimodels = [];
    this.allDettsils.forEach(element => {
      if (Aimodels.length > 0) {
        let present = false;
        Aimodels.forEach(data => {
          if (data.value == element.project_name) {
            present = true;
          }
        })
        if (!present) {
          Aimodels.push({ value: element.project_name, label: element.project_name })
        }
      } else {
        Aimodels.push({ value: element.project_name, label: element.project_name })
      }
    });
    // contry
    let country=[];
    
    //
    /*
    this.allDettsils.forEach(element => {
      if (country.length > 0) {
        let present = false;
        country.forEach(data => {
          if (data.value == element.Country) {
            present = true;
          }
        });
        if(element.Country === "us" || element.Country=== "ca" )
        {
        if (!present) {
          country.push({ value: element.Country, label: element.Country })
        }
      } else {
        country.push({ value: element.Country, label: element.Country })
      }
    }
    });
    //
    
    
 if (country.length > 0) {
  country.push({ value: "All", label: "All" })
}
    */
   
  country.push({ value: "ca", label: "ca" });
  country.push({ value: "us", label: "us" });
  country.push({ value: "All", label: "All" });

    let statusList=[];
   
    //
    this.allDettsils.forEach(element => {
      if (statusList.length > 0) {
        let present = false;
        statusList.forEach(data => {
        if (data.value == element.Status) {
          present = true;
        }
        });
        if(element.Status!="")
        {
        if (!present) {
        statusList.push({ value: element.Status, label: element.Status })
        }
      } else {
         if(element.Status.trim()!="")
        {
        //
        statusList.push({ value: element.Status, label: element.Status });
        }
      }
    }
    else 
      {
      if(element.Status!=""){
        statusList.push({ value: element.Status, label: element.Status })
      }
      }
      });
    //
     
    if (statusList.length > 0) {
      statusList.push({ value: "All", label: "All" })
    }
   //
    if (scountry!= "") {
      if (scountry === "All") {
        modelData = modelData;
      }
      else{
      
      modelData = modelData.filter(element => element.Country == scountry);
      }
    
    } 
    
    if (status != "") {
      
      if (status === "All") {
        modelData = modelData;
      }
      else
      {
        modelData = modelData.filter(element => element.Status.toLowerCase().startsWith(status.toLowerCase()));  
      }
     // modelData = modelData.filter(element => element.Status == status);    
    } 
    
    if (ship != "") {
      modelData = modelData.filter(element => element.ShipTo.toLowerCase().startsWith(ship.toLowerCase()));    
    } 
    
    if (plant != "") {
      modelData = modelData.filter(element => element.Plant.toLowerCase().startsWith(plant.toLowerCase()));    
    } 
    if (po != "") {
      modelData = modelData.filter(element => element.PO.toLowerCase().startsWith(po.toLowerCase()));        
    } 
    
    if (order != "") {
      modelData = modelData.filter(element => element.OrderType.toLowerCase().startsWith(order.toLowerCase()));    
    } 
    
    
    if (so != "") {
      modelData = modelData.filter(element => element.SONumber.toLowerCase().startsWith(so.toLowerCase()));     
    } 
    
    
    if (cemail != "") {
      modelData = modelData.filter(element => element.Customer_email_address.toLowerCase().startsWith(cemail.toLowerCase()));    
    } 
        
    
    
    
    if (searchText != "") {
     
      modelData = modelData.filter(element => element.RequestDetailsID.trim().toUpperCase().startsWith(searchText.toUpperCase()) ||
    element.SONumber.trim().toUpperCase().startsWith(searchText.toUpperCase()) ||
    element.PO.trim().toUpperCase().startsWith(searchText.toUpperCase()) ||
    element.OrderType.trim().toUpperCase().startsWith(searchText.toUpperCase()) ||      
    element.ShipTo.toString().trim().toUpperCase().startsWith(searchText.toUpperCase()) ||    
    element.Plant.trim().toUpperCase().startsWith(searchText.toUpperCase()) );
    }
    
    
    //table filters start
    
    let coun = selectedTFcountry;
    let counval = coun.value?coun.value:"";
     
    if(counval !== "" && counval !== "All"){     
    modelData = modelData.filter(element => ( element.Country == counval));    
}

let couns = selectedTFStatus;
    let counsval = couns.value?couns.value:"";
     
    if(counsval !== "" && counsval !== "All"){     
    modelData = modelData.filter(element => ( element.Status == counsval));    
}





    //table filters end
    
    
    //
    await this.setState({ loadingProjects: false});
    this.setState({ myModels: modelData, headers: keys, AI_models: Aimodels,country: country,statusList:statusList});
    this.setState({ fromDate: fromDate, toDate: toDate });
    //
  }
  
  public tableDataShow = () => {
    const { myModels,currentPage, displayCountPerPage,currentLength} = this.state;
    const indexOfLastRec = currentPage * displayCountPerPage;
    const indexOfFirstRec = indexOfLastRec - displayCountPerPage;
    const myModelsNew = myModels.slice(indexOfFirstRec, indexOfLastRec);
  
     // Logic for displaying page numbers
     let isCheckBox = false , isSelectAll = true

      if(myModels.length>0){
         isCheckBox =  myModels.every( (val, i, arr) => val["RequestDetailsID"] === arr[0]["RequestDetailsID"] )
        }
       
        Object.keys(myModels).map(key=>{
          if(myModels[key]["isChecked"]!=true){
            isSelectAll = false
          }
        })
      let id = ""
      if(isCheckBox){
        id = myModels[0]["RequestDetailsID"]
      }
      const dark: ICustomizations = {
        settings: {
          theme: getDarkTheme(),
        },
        scopedSettings: {},
    };
    return (
      <div   >
        <Customizer {...dark}>
          <Dialog
                          onDismiss={()=>{this.setState({hidePopUp:true})}}
                          hidden={this.state.hidePopUp}
                          dialogContentProps={{
                              type: DialogType.normal,
                              title: "There are other records with this request id, do you want to update them as well?"
                          }}
                          >
                          <DialogFooter>
                              <PrimaryButton
                                  onClick={()=>this.updateStatusAll()}
                                  text={"Yes"}/>
                                  <PrimaryButton
                                  onClick={()=>{this.setState({hidePopUp:true})}}
                                  text={"No"}/>
                          </DialogFooter>
                    </Dialog>
          </Customizer> 
          
          <Modal isOpen={!this.state.hideSuccPopUp} centered={true}   >
               
                <ModalBody style={{backgroundColor:'black'}}>
                    <label ><h5><p style={{color:'white'}}> Clear Exception before selecting 'Success' status!</p></h5> </label>
                </ModalBody>
                <ModalFooter style={{backgroundColor:'black'}}>
                    
                    <button
                    className="btn-custom btn-xl mr-2 float-right"  style={{width:"80px"}}
                   
                        onClick={()=>{this.setState({hideSuccPopUp:true})}}
                       >
                        OK
                    </button>
                   
                </ModalFooter>
            </Modal>
                
             
        <div className="card wrap-body-my_models shadow model-data mt-2 filterGrid">
          <table className="table table-dark table-striped" style={{ fontSize: '12px' }}>
            <thead>
              <tr>
              <th style={{ width: '50px' }}>
                
              {isCheckBox?<input type="checkbox" checked={isSelectAll} onClick={(e)=>this.handleClickNew(e,id)} />:null}
                 
               </th>
              
                <th style={{ width: "1000px", tableLayout: "fixed" }} >Order Type
                
               
                </th>
                <th style={{ width: "1000px", tableLayout: "fixed" }}>PO Number</th>
                <th style={{ width: "900px", tableLayout: "fixed" }}>Request Details ID</th>
                <th style={{ width: "850px", tableLayout: "fixed" }}>Ship To</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>Plant</th>
                <th style={{ width: "750px", tableLayout: "fixed" }}>SO Number</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>Message
                <button  
                
                style={{ background: '#222830',  color: 'lightgray', border:'none' 
                         }}
                                                    onClick={() => this.TF_Status()}>
                                                       <i className="fas fa-angle-down" style={{ }}></i>
                                               
                                                </button>
                                                {this.state.displayStatusdd?
                                                  <div>
                                                    <Select options={this.state.statusList}
                          value={this.state.selectedTFStatus}
                          onChange={this.getTFStatus}
                          className="react-select-container z-index-19"
                          isClearable={false}
                          placeholder="Status"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#161a1f",
                              primary: "#6b727d",
                              neutral0: "#222830",
                              neutral20: "#44474c",
                              neutral30: "#272c33",
                              neutral50: "#fff",
                              neutral80: "#9da7b5",
                            },
                          })}
/>
                                                  </div>  
                                              :
                                              <div>
                                                </div>  
                                              }
                </th>
                <th style={{ width: "500px", tableLayout: "fixed" }}> Country
                <button                 
                style={{ background: '#222830',  color: 'lightgray', border:'none' 
                         }}
                                                    onClick={() => this.TF_Country()}>
                                                      
                                                       <i className="fas fa-angle-down" style={{ }}></i>
                                               
                                                </button>
                                                {this.state.displayCountrydd?
                                                 <div>
                                                     <Select options={this.state.country}
                          value={this.state.selectedTFcountry}
                          onChange={this.getTFCountry}
                          className="react-select-container z-index-19"
                          isClearable={false}
                          placeholder="Country"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#161a1f",
                              primary: "#6b727d",
                              neutral0: "#222830",
                              neutral20: "#44474c",
                              neutral30: "#272c33",
                              neutral50: "#fff",
                              neutral80: "#9da7b5",
                            },
                          })}

                        />
                                                    
                                                  </div>:
                                                  <div></div>
                                                }
                                                </th>
                                                
                                            
                <th style={{ width: "500px", tableLayout: "fixed" }}>Status</th>
                
                <th style={{ width: "500px", tableLayout: "fixed" }}>Customer Email
                <button  
                
                style={{ background: '#222830',  color: 'lightgray', border:'none' 
                         }}
                                                    onClick={() => this.TF_CustEmail()}>
                                                       <i className="fas fa-angle-down" style={{ }}></i>
                                               
                                                </button>
                </th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>Email Sent Date
                <button  
                
                style={{ background: '#222830',  color: 'lightgray', border:'none' 
                         }}
                                                    onClick={() => this.TF_CustEmailDateNew()}>
                                                       <i className="fas fa-angle-down" style={{ }}></i>
                                               
                                                </button>
                </th>
                
                <th style={{ width: "500px", tableLayout: "fixed" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {myModels && myModels.map((model, index) => {
                 let eRec= (model.Status==="Not Started-Exception")?true:false;
                 let eFailed= (model.Status==="Failed")?true:false;
                 return index <= currentLength ? (
                    <tr key={index} className= {eRec?"bgRed":eFailed?"bgYellow":""}>
                    <td>
                      {
                      <input type="checkbox" checked={model["isChecked"]} onClick={(e) => {this.validateMultiple(model,e,index)}}   />
                    }
                      </td>
                      <td  > 
                      <div className= {eRec?"bgRed":eFailed?"bgYellow":""}>{model.OrderType}
                      </div></td>
                      <td  >
                      <div className= {eRec?"bgRed":eFailed?"bgYellow":""}>
                        {model.PO}
                        </div>
                      </td>
                      <td  >
                        <div className= {eRec?"bgRed":eFailed?"bgYellow":""}>
                        {model.RequestDetailsID}
                        </div>
                      </td>
                      <td  >
                      <div className= {eRec?"bgRed":eFailed?"bgYellow":""}>
                        {model.ShipTo}
                        </div>
                      </td>
                      <td   >
                      <div className= {eRec?"bgRed":eFailed?"bgYellow":""}>
                        {model.Plant}
                        </div>
                      </td>
                      <td   >
                      <div className= {eRec?"bgRed":eFailed?"bgYellow":""}>
                        {model.SONumber}
                          </div>
                      </td>
                      <td  >
                      <div className= {eRec?"bgRed":eFailed?"bgYellow":""}>
                        {model.Status}
                        </div>
                      </td >
                      <td  >
                      <div className= {eRec?"bgRed":eFailed?"bgYellow":""}>
                        {model.Country}
                        </div>
                      </td>
                      <td>
                        { 
                        ( model.Status==="Not Started-Exception"||    model.Status==="Failed" ||                   
                        model.Status==="Exception")?
                        
                          <span>
                          <i className="fa fa-circle" style={{ fontSize: '8px', padding: '1px' }}></i>
                          <i className="fa fa-circle" style={{ fontSize: '8px', color: 'red', padding: '1px' }}></i>
                          <i className="fa fa-circle" style={{ fontSize: '8px', padding: '1px' }}></i>
                        </span> :
                         model.Status==="Completed"?
                        <span>
                            <i className="fa fa-circle" style={{ fontSize: '8px',  padding: '1px' }}></i>
                            <i className="fa fa-circle" style={{ fontSize: '8px',color: 'green', padding: '1px' }}></i>
                            <i className="fa fa-circle" style={{ fontSize: '8px', padding: '1px' }}></i>
                          </span> :
                           model.Status==="Not Started"?
                           <span>
                           <i className="fa fa-circle" style={{ fontSize: '8px', padding: '1px' }}></i>
                           <i className="fa fa-circle" style={{ fontSize: '8px',color: 'orange', padding: '1px' }}></i>
                           <i className="fa fa-circle" style={{ fontSize: '8px',  padding: '1px' }}></i>
                         </span>:                       
                         
                         <span>
                         <i className="fa fa-circle" style={{ fontSize: '8px', padding: '1px' }}></i>
                         <i className="fa fa-circle" style={{ fontSize: '8px', padding: '1px' }}></i>
                         <i className="fa fa-circle" style={{ fontSize: '8px', padding: '1px' }}></i>
                       </span>
                          }
                      </td>
                      <td  > 
                      <div className= {eRec?"bgRed":eFailed?"bgYellow":""}>{model.Customer_email_address}
                      </div></td>
                      <td  > 
                      <div className= {eRec?"bgRed":eFailed?"bgYellow":""}>{model.Email_Sent_Date}
                      </div></td>
                      
                      
                      <td className="action-control">
                        {/* <button role="button" className="view"
                          onClick={() => this.handleShow(model)}>
                         <i className="fa fa-eye bg-color-1" aria-hidden="true"></i>
                        </button> */}
                        <button role="button" className={model.Status=="No Action Required"?"":"view"} disabled={model.Status=="No Action Required"?true:false}
                          onClick={() => this.goToModel(model)}>
                          <i className="fa fa-edit bg-color-1" aria-hidden="true"></i>
                        </button>
                      </td>
                     
                    </tr>
                  
                ):null
              })}
               
            </tbody>
          </table>
          {this.state.currentLength<=myModels.length?(
               <div className="click-here-css" 
               onClick={()=>{this.setState({currentLength:this.state.currentLength+20})}}>Show more</div>
          ):null}
          {/* <span className="show-results-css">Remaining records:{this.state.myModels.length - this.state.currentLength > 0 ? this.state.myModels.length - this.state.currentLength : 0}</span> */}
          <span className="show-results-css" >Showing results &nbsp;
           {this.state.currentLength > this.state.myModels.length?this.state.myModels.length:this.state.currentLength} out of {this.state.myModels.length}</span>
        </div>
        
      </div>
    );
  }


  public render() {
    //
    const { myModels,currentPage, displayCountPerPage,country,selectedRecords,updatestatusSelVal,AllstatusList} = this.state;
     console.log("no of models- doc mgmt==>"+myModels.length);
     // Logic for displaying page numbers
     console.log("first model DOC MGT==>"+JSON.stringify(myModels[0]));
     
     const changedmstatusOptions = [
      { value: 'Success', label: 'Success' },
      { value: 'Completed', label: 'Completed' },
    //  { value: 'Exception', label: 'Exception' },
      { value: 'Not Started', label: 'Not Started' },
      { value: 'Not Started-Exception', label: 'Not Started-Exception' },
      { value: 'No Action Required', label: 'No Action Required' },
  ];
  
     const pageNumbers = [];
     for (let i = 1; i <= Math.ceil(myModels.length / displayCountPerPage); i++) {
       pageNumbers.push(i);
     }
     
     const lastpage = Math.ceil(myModels.length / displayCountPerPage);
 
     let numeval =Math.trunc ((currentPage+displayCountPerPage-1)/displayCountPerPage);
     let ePage  =  numeval*displayCountPerPage;
     if(ePage>lastpage)
     {
      ePage=lastpage;
     }
     const sPage =  ePage-10+1;
     const renderPageNumbers = pageNumbers.map(number => {       
      let classes = currentPage === number ? "pageactive" : '';   
         
      if ((number <= ePage)&&(number >= sPage)) {        
       return (
         <li
           key={number}           
           className={classes}           
           id={number}
           onClick={(e)=>this.handlePageClick(e)}  >
           {number}
         </li>
       );
     }
    });
     
    //
    return (
      <>
        <HeaderComponent
          history={this.props.history}
          match={this.props.match}
          location={this.props.location} />
        <LoadingOverlay
          active={this.state.loadingProjects}
          spinner
          className={this.state.loadingProjects ? "wrap-queue-height" : ""}
          text={this.state.loaderText}
        >
            {this.state.loadModal ? <Spinner
            size={SpinnerSize.large}
            label={this.state.loaderText}
            ariaLive="off"
            className="mt-5"
            labelPosition="bottom"
          /> :
            <div className="container-fluid animated fadeIn">
              {this.state.loadProcess ? <Spinner
                size={SpinnerSize.large}
                label={this.state.loaderText}
                ariaLive="off"
                className="mt-5"
                labelPosition="bottom"
              /> : 
              <>
              <div className="row mt-2" id="accordionDM">
<div className="col-md-6" style={{ marginTop: '4px' }}>
  </div>
  
<div className="col-md-4" style={{ marginTop: '10px' }}>
                        <div style={{ display: 'flex' }}>
                        {/* <input type="file" onChange={this.fileHandler} style={{"padding":"10px","display":"block"}} />
<OutTable data={this.state.rows} columns={this.state.cols} tableHeaderRowClass="heading" />
       123 */}
                          <input type="text" placeholder="search" value={this.state.searchText} 
                          onChange={(e) => this.searchSpace(e)} 
                          style={{ background: '#222830', border: '1px solid #222830', color: 'lightgray', 
                          width: '100%', borderRadius: '3px', padding: '5px' }} /> 
                           <i className="fas fa-search" style={{ marginLeft: '-5%', marginTop: '10px' }}></i>

                        </div>
                      </div>
                                       
                  
  <div className="col-md-2" style={{ marginTop: '4px' }}>
 
                    <button className="btn-custom float-right" onClick={() => this.updateModels(true)} style={{ marginRight: '1%', fontWeight: 'bold', borderRadius: '5px' }}>
                      <i className="fas fa-sync-alt"></i> Refresh  </button>
                   
                        <button className="btn-custom float-right" 
                        
                                               onClick={this.outClick} style={{ marginRight: '1%', fontWeight: 'bold', borderRadius: '5px' }}>
                      Advanced Filters   </button> 
                     
                      
                  {/* <button className="btn-custom float-right" onClick={() => this.updateModels(true)} style={{ marginRight: '1%', fontWeight: 'bold', borderRadius: '5px' }}>
                      Process  </button> */} 
                  </div>



                </div>
                <div className="row mt-2" id="accordionDM1">
                <div className="col-md-8" style={{ marginTop: '4px' }}>
                  </div>
                <div className="col-md-4" style={{ marginTop: '4px' }}>
  {selectedRecords&&selectedRecords.length>0?
  <div className="row">
     <div className="col-md-8">
  <Select options={changedmstatusOptions}
  value={updatestatusSelVal}                                          
  onChange={e => this.SelectRecordStatus(e)}
  className="react-select-container z-index-19"
  isClearable={true}
  theme={(theme) => ({
      ...theme,
      colors: {
          ...theme.colors,
          primary25: "#161a1f",
          primary: "#6b727d",
          neutral0: "#222830",
          neutral20: "#44474c",
          neutral30: "#272c33",
          neutral50: "#fff",
          neutral80: "#9da7b5",
      },
  })}

/>
</div>
<div className="col-md-4">
  <button className={updatestatusSelVal!=null&&updatestatusSelVal["value"]?"btn-custom float-right":"btn-custom css-status float-right"}
                        
                        onClick={() => this.UpdateRecordStatus()} 
                        disabled={updatestatusSelVal!=null&&updatestatusSelVal["value"]?false:true}
                        style={{ marginRight: '1%', fontWeight: 'bold', borderRadius: '5px' }}>
                    Update Status   </button>
                    </div>
</div>:
<div>
  </div> 
  }
  
  
  
  </div>
                  </div>
                </>
               
                
                }
             
              {this.tableDataShow()}
            
            {/* <div className="row mt-2">
                <div className="col-10 ">
                  </div>
                  <div className="col-2 ">
                  <ul id="page-numbers">
                 <li>
                 <span 
                 
                 onClick={(e)=>this.handlePreviousClick(e)}  
                >&laquo;</span>
                 </li>
         {renderPageNumbers}
         <li>
         <span 
          onClick={(e)=>this.handleNextClick(e)}
         >&raquo;</span> </li>
                 
            
           </ul>
                  </div>
                </div>
                <div className="row ">
                <div className="col-8 ">
                  </div>
                  <div className="col-4 ">
                  <ul id="page-numbers">
                 
                 Displaying Page <span className="fcolor">&nbsp; {currentPage}&nbsp;</span> of  <span className="fcolor">&nbsp;{lastpage}&nbsp; </span>pages
            
           </ul>
                  </div>
                </div>
              
              
            
              <div>
             
              </div> */}

            </div>
          }
       

{this.state.displayAdvancedPopup ?
      (
                    <div className="doc_mgt_add_filters_model_add " >
                        <LoadingOverlay
                            active={false}
                            spinner
                            text="Creating Validation">
                            <div className="row " style={{ marginRight:"2%",marginTop:"-3%", float:"right"}}>
                             
                                <div className="col-md-9 offset-md-3">
                                <div ref={node => { this.node = node; }}>
                                    <div className="card shadow bgWhite1" >

                                        <div className="card-header bgWhite1">
                                            <div className="text-center">
                                                <h5>Add Filters</h5>

                                            </div>
                                        </div>

                                        <div className="card-body bgWhite1 adpopscr"  >

                                            <div className="row">

                                                <div className="col-md-6" >
                                                    <label >PO Number:</label>
                                                    <input type="text" className="form-control" id="af_PO" 
                                                    name="endpoint_name" value={this.state.af_PO}
                                                      
                                                        onChange= {e => this.changeField_PO(e.target.value)}
                                                        />
                                             
                                             
                                                </div>

                                                <div className="col-md-6" >
                                                    <label>Order Type:</label>
                                                    <input type="text" className="form-control" id="af_Order" name="endpoint"
                                                    value={this.state.af_Order}
                                                         
                                                        onChange= {e => this.changeField_Order(e.target.value)}
                                                        />                                                    
                                                </div> 
                  <div className="col-md-6" >
                                                    <label>Ship To:</label>
                                                    <input type="text" className="form-control" id="af_Ship" 
                                                    value={this.state.af_Ship}
                                                    name="endpoint_name"                                                        
                                                        onChange= {e => this.changeField_Ship(e.target.value)}
                                                        />                                            
                                                    
                                                </div>
                                                
                                                
                                                
                                                <div className="col-md-6" >

                                                    <label>Plant:</label>
                                                    <input type="text" className="form-control" id="af_Plant" 
                                                     value={this.state.af_Plant}
                                                    name="endpoint_name"
                                                    
                                                    onChange= {e => this.changeField_Plant(e.target.value)}
                                                      />
                                             

                                                </div>

                                                <div className="col-md-6" >
                                                <label> From Date:</label>
                                                <input type="date"
                                                
                                                id="af_FromDate"
                             value={this.state.af_FromDate}
                             className="form-control"
                            placeholder="From Date"
                            

                              maxLength={20} minLength={4} 
                              onChange={(e) => this.changeField_FromDate(e.target.value)} name="createModel" />
                          </div>
                                                
                                                
                                                    
                                             
                                               
                                                
                                                <div className="col-md-6" >
                                                <label> To Date:</label>
                                                <input type="date"
                                                 className="form-control"
                                                id="af_ToDate"
                             value={this.state.af_ToDate}
                            
                            placeholder="From Date"
                         
                              maxLength={20} minLength={4} 
                              onChange={(e) => this.changeField_ToDate(e.target.value)} name="createModel" />
                              
                                                
                                                
                                             
                                                </div>
                                                
                                                <div className="col-md-6" >
                                                <label> Country:</label>
                                                
                                                <Select options={this.state.country}
                                                ref={node => { this.nodeCountryDropdown = node; }}
                                                menuPortalTarget={document.body} 
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                          value={this.state.selectedcountry}
                          onChange={this.getCountry}
                          className="react-select-container z-index-19"
                          isClearable={false}
                          placeholder="Country"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#161a1f",
                              primary: "#6b727d",
                              neutral0: "#222830",
                              neutral20: "#44474c",
                              neutral30: "#272c33",
                              neutral50: "#fff",
                              neutral80: "#9da7b5",
                            },
                          })}

                        />
                        
                        
                                                {/* 
                                                    <input type="text" className="form-control" id="af_Country" 
                                                     value={this.state.af_Country}
                                                    name="endpoint_name"
                                                     
                                                        onChange= {e => this.changeField_Country(e.target.value)}
                                                      />
                                                      */}
                                             
                                                </div>
                                                
                                                <div className="col-md-6" >
                                                <label> Status:</label>
                                                
                                                
                                                <Multiselect
                
              
               
                showArrow options={AllstatusList} displayValue="value" showCheckbox={true} 
                onSelect={this.onSelect} onRemove={this.onRemove} selectedValues={this.state.af_StatusList}
                avoidHighlightFirstOption  closeIcon="close" closeOnSelect={false}  />
                  
                 
                 {/* 
                 
                                                <Select options={this.state.AllstatusList} 
                                                menuPortalTarget={document.body} 
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                 ref={node => { this.nodeDropdown = node; }}
                          value={this.state.selectedStatus}
                          onChange={this.getStatus}
                          className="react-select-container z-index-19"
                          isClearable={false}
                          placeholder="Status"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#161a1f",
                              primary: "#6b727d",
                              neutral0: "#222830",
                              neutral20: "#44474c",
                              neutral30: "#272c33",
                              neutral50: "#fff",
                              neutral80: "#9da7b5",
                            },
                          })}
/>*/}
                                                {/* 
                                                    <input type="text" className="form-control" id="af_Status"
                                                      value={this.state.af_Status}
                                                    name="endpoint_name"
                                                    onChange= {e => this.changeField_Status(e.target.value)}
                                                        />
                                             */}
                                                </div>
                                                
                                                
                                                
                                                <div className="col-md-6" >
                                                    <label>SO:</label>
                                                    <input type="text" className="form-control" id="af_SO" name="endpoint"
                                                    value={this.state.af_SO}
                                                         
                                                        onChange= {e => this.changeField_SO(e.target.value)}
                                                        />                                                    
                                                </div> 
                  <div className="col-md-6" >
                                                    <label>Customer Email:</label>
                                                    <input type="text" className="form-control" id="af_CEmail" 
                                                    value={this.state.af_CEmail}
                                                    name="endpoint_name"                                                        
                                                        onChange= {e => this.changeField_CEmail(e.target.value)}
                                                        />                                            
                                                    
                                                </div>
                                                

                                            </div>

                                        </div>

                                    </div>

                                    <div className="card-footer text-right bgWhite1">
                                        <button type="submit"
                                         
                                          className="btn btn-sm mr-2"  onClick={() => this.ApplyAdvancedFilters()}>Apply Filters</button>
                                      
                                      <button type="submit"
                                         
                                         className="btn btn-sm mr-2"  onClick={() => this.ClearAdvancedFilters()}>Clear Filters</button>
                                     
                                        <button type="button"
                                            className="btn btn-sm "  onClick={() => this.outClick()} >Cancel</button>
                                    </div>
                                 </div>
                                </div>
                                </div>  
                        </LoadingOverlay>
                   
      </div>  )  :null          
                }
        </LoadingOverlay>
      </>
    );
  }

  
  public onSelect=(selectedList, selectedItem)=> {
    //this.getStatus
    const { AllstatusList} = this.state;
    
    //debugger;
     if(selectedItem)
     {
       if(selectedItem.value === "All")
       {
           this.setState({af_StatusList:AllstatusList});
       }
       else
       {
           this.setState({af_StatusList:selectedList});
       }
    }
    
    /*
    if (event != null) {
      
      this.setState({ selectedStatus: event });
      this.setState({af_StatusList:selectedList});
      
    } else {
    
      this.setState({ selectedStatus: [] });
      this.setState({af_Status:""});
      
    }*/
    
}
public onRemove=(selectedList, selectedItem)=> {
  
  this.setState({af_StatusList:selectedList});
  
  
  
}

  /**
   * Get Queue Data
   */
  public goToModel = async (model) => {
    let modelArray = []
    Object.keys(this.allDettsils).map(key=>{
      if(model["RequestDetailsID"] == this.allDettsils[key]["RequestDetailsID"]){
        modelArray.push(this.allDettsils[key])
      }
    })
    localStorage.setItem("Customer", model.Customer);
    localStorage.setItem("fileName", model.Filename);
    
    model.Attachment_SAS_Url= model.Attachment_SAS_Url?model.Attachment_SAS_Url:"";
    model.Body_SAS_Url= model.Body_SAS_Url?model.Body_SAS_Url:"";   
   
      model.Attachment_SAS_Url = model.Attachment_SAS_Url.trim();
     
      model.Body_SAS_Url = model.Body_SAS_Url.trim();
     if(model["isChecked"]){
       delete model["isChecked"]
     }
    localStorage.setItem("reqLength", JSON.stringify(modelArray.length));
    localStorage.setItem("selectedDocument", JSON.stringify(model));
   /*
    let selectedFilters={      
      selectedcountry:this.state.selectedcountry,
      selectedStatus:this.state.selectedStatus,
      fromDate:this.state.fromDate,
      toDate:this.state.fromDate!==""?this.state.toDate:"",
      searchText:this.state.searchText,
    };
    */
    let selectedFilters={      
      af_Country:this.state.af_Country,
      af_Status:this.state.af_Status,
      fromDate:this.state.af_FromDate,
      af_FromDate:this.state.af_FromDate,
      af_ToDate:this.state.af_ToDate,      
      af_Order:this.state.af_Order,
      af_PO:this.state.af_PO,
      af_Plant:this.state.af_Plant,
      af_Ship:this.state.af_Ship, 
      af_SO:this.state.af_SO, 
      af_CEmail:this.state.af_CEmail,
      searchText:this.state.searchText,
      
 displayCountrydd:this.state.displayCountrydd,
 displayStatusdd:this.state.displayStatusdd, 
  
selectedTFStatus:this.state.selectedTFStatus,
selectedTFcountry:this.state.selectedTFcountry
    };
    
    
    localStorage.setItem("DocMgtBack", "N");
   // localStorage.setItem("DocMgtModelData", JSON.stringify(this.state.myModels));
    
    localStorage.setItem("selectedDocMgtFilters", JSON.stringify(selectedFilters));
    this.props.history.push(`/editTagsData_for_Document`);
  }
  /**
  * get updated models
  */
  private updateModels = async (flag?: boolean) => {
  /*  this.records = [];
    this.setState({ selectedcountry: [],selectedStatus:[],fromDate:'',toDate:'' ,searchText:null});
    
    this.setState({ loadModal: true, selectedFilter: '', loaderText: 'Loading file to preview', appliedFilters: '' });
    const modelData = await this.props.userOperationsActions.documentMangement();
    this.setState({ loadModal: false, myModels: modelData, allData: modelData });
    localStorage.setItem("DocMgtBack", "N");
    */
    //this.props.history.push(`/DocumentManagement`);
    
    window.location.reload();
    
  }
  
  
  public showAdvancedFiltersPopup= async()=>
  {
  
    const { displayAdvancedPopup } = this.state;
    this.setState({ displayAdvancedPopup: !displayAdvancedPopup });
  }
  public ApplyAdvancedFilters= async()=>
  {
    this.outClick();
    let enddate ;
    if(this.state.af_ToDate==="" && this.state.af_FromDate!=="" )
    {  
      //enddate = moment().format("MM/DD/YYYY");
      //this.setState({af_ToDate:moment().format("MM/DD/YYYY")});
      enddate = moment().format("YYYY-MM-DD");
      this.setState({af_ToDate:moment().format("YYYY-MM-DD")});
    }else{
      enddate = this.state.af_ToDate;
    }
    
    
    //debugger;
    this.getDocMgtDatabydate_af(this.state.af_FromDate,enddate );
     
    this.setState({ displayAdvancedPopup: false });
  }
  
  public ClearAdvancedFilters= async()=>
  {
    this.setState({ af_Country:"",
      af_Status: "",
      af_FromDate:"",
      af_ToDate: "",
      af_Order: "",
      af_PO: "",
      af_Plant: "",                         
      af_Ship:"",   
      af_SO:"", 
      af_CEmail:"",                          
      searchText:null,
            });  
            
            this.setState({ selectedStatus: [] });
            this.setState({ selectedcountry: [] });
            
  }
  
  public reloadStatusUpdate = async() => {
    this.setState({
      loadModal:true
    })
    let p = [...this.state.myModels]
      Object.keys(p).map(key=>{
          p[key]["isChecked"] = false
      })
    this.setState({ selectedRecords: [] })
    this.setState({
      myModels:p
    })
    let modelData
    if(this.state.af_FromDate!=""){
      /*
      modelData = await this.props.userOperationsActions.documentMangementByDate
      (moment(this.state.af_FromDate).startOf('day').format("MM/DD/YYYY[T]HH:mm:ss"),
      moment(this.state.af_ToDate).endOf('day').format("MM/DD/YYYY[T]HH:mm:ss"));
      
      */
      modelData = await this.props.userOperationsActions.documentMangementByDate
      (moment(this.state.af_FromDate).startOf('day').format("YYYY-MM-DD[T]HH:mm:ss"),
      moment(this.state.af_ToDate).endOf('day').format("YYYY-MM-DD[T]HH:mm:ss"));
      
    }
    else{
      modelData = await this.props.userOperationsActions.documentMangement();
    }

    this.getDocMgtDatabydateCountryStatus_af(this.state.af_FromDate,this.state.af_ToDate,          
             
     
    this.state.af_Country?this.state.af_Country:"",
    this.state.af_Status?this.state.af_Status:"",
       
    this.state.af_Order?this.state.af_Order:"",
    this.state.af_PO?this.state.af_PO:"",   
    
    this.state.af_Country?this.state.af_Plant:"",
    this.state.af_Status?this.state.af_Ship:"",   
    
    this.state.af_SO?this.state.af_SO:"",
    this.state.af_CEmail?this.state.af_CEmail:"",   
    
    this.state.searchText?this.state.searchText:"",
    
    this.state.selectedTFStatus,
    this.state.selectedTFcountry,
    modelData
      );
      this.setState({
        loadModal:false,
        selectedRecords:[],
        selectAllReqId:''
      })
      this.records = []
  }

  public UpdateRecordStatus= async()=>
  {
   // const endpointURL = docMgt_UpdateStatus(reqid,selectedstatus.value);
    let selectedstatus = this.state.updatestatusSelVal;    
    //make API Call  
    let selRecords=this.state.selectedRecords?this.state.selectedRecords:[];

    if(selRecords.length>0)
    {
      this.setState({
        loadModal:true
      })
     // let reqid =selRecords[0].RequestDetailsID;
     let count = 0 ;
     
     
     let objectRowKeys =[];
     selRecords.forEach(element=>{
       objectRowKeys.push(element.RowKey);
     });
     
     const endpointURL = docMgt_UpdateStatus(selRecords[0]["RequestDetailsID"],selectedstatus.value);   
     //debugger;
     const headers = accessToken();
     axios( endpointURL , { method: "POST" ,  data: {"row_key":objectRowKeys}, headers}).
     then((resp) => {
       if (resp.status === 200 || resp.status === 201) {           
        
           toast.success("Records updated Sucessfully!", { position: toast.POSITION.TOP_CENTER });
           this.reloadStatusUpdate();          
      
       }
     });
     /*
      Object.keys(selRecords).map(key=>{
        console.log(selRecords[key]["RequestDetailsID"],selectedstatus.value,selRecords[key]["RowKey"])
        const endpointURL = docMgt_UpdateStatus(selRecords[key]["RequestDetailsID"],selectedstatus.value,
        selRecords[key]["RowKey"]
        );
        axios( endpointURL , { method: "GET" ,  headers}).
        then((resp) => {
          if (resp.status === 200 || resp.status === 201) {
            count = count + 1
           // this.setState({tagsShow:true})
           if(count == selRecords.length){
              toast.success("Records updated Sucessfully!", { position: toast.POSITION.TOP_CENTER });
                this.reloadStatusUpdate();
             // window.location.reload();
           }
          }
        });        
      })
      
      */
      
    }
    
  }
  
  public UpdateRecordStatus_old16052022= async()=>
  {
   // const endpointURL = docMgt_UpdateStatus(reqid,selectedstatus.value);
    let selectedstatus = this.state.updatestatusSelVal;    
    //make API Call  
    let selRecords=this.state.selectedRecords?this.state.selectedRecords:[];

    if(selRecords.length>0)
    {
      this.setState({
        loadModal:true
      })
     // let reqid =selRecords[0].RequestDetailsID;
     let count = 0 
      Object.keys(selRecords).map(key=>{
        console.log(selRecords[key]["RequestDetailsID"],selectedstatus.value,selRecords[key]["RowKey"]);
        const endpointURL = "";
       // const endpointURL = docMgt_UpdateStatus(selRecords[key]["RequestDetailsID"],selectedstatus.value,
       // selRecords[key]["RowKey"]
       // );
       const headers = accessToken();
       
        axios( endpointURL , { method: "GET" ,  headers}).
        then((resp) => {
          if (resp.status === 200 || resp.status === 201) {
            count = count + 1
           // this.setState({tagsShow:true})
           if(count == selRecords.length){
              toast.success("Records updated Sucessfully!", { position: toast.POSITION.TOP_CENTER });
                this.reloadStatusUpdate();
             // window.location.reload();
           }
          }
        });
      })
    }
    
  }
  
  
  public SelectRecordStatus= async(e)=>
  {
   // this.setState({ updatestatusSelVal: e });
   //debugger;
   
   if(e)
   {
     //check for success status
     if(e.value!== "Success")
     {
       this.setState({ updatestatusSelVal: e });
     }
     else
     {
     let allowModification = true;
     let exceptionRecord;
     let selRecords=this.state.selectedRecords?this.state.selectedRecords:[];
         //
        
         selRecords.forEach(element=>{                   
             let isExceptionFeild = false; 
             if(element["ShipTo"]==="Exception" || element["ReqDateH"]==="Exception" || element["Material"]==="Exception"
                ||element["Plant"]==="Exception" || element["Quantity"]==="Exception" ) 
                        {
                              allowModification = false;
                              exceptionRecord=element;
                        }       
       });
       
       if(allowModification)
       {
         this.setState({ updatestatusSelVal: e });
       }
       else
       {
        // toast.error(`Clear Exception: (RequestDetailsID: ${exceptionRecord["RequestDetailsID"]} ) before selecting 'Success' status!`, { position: toast.POSITION.TOP_CENTER });
         this.setState({
          hideSuccPopUp:false});
       }
      }
       }
       else
       {
        this.setState({ updatestatusSelVal: [] });
        
       }
       
       
       
  }
  
  
   
  
  
  
  public CancelAdvancedFilters= async()=>
  {
    this.setState({ displayAdvancedPopup: false });
  }
  
  
  
  public changeField(key,value)
  {
    //const { displayAdvancedPopup } = this.state;
  //  console.log(event.target);
    //const { key, value } = event.target;
    this.setState(previousState => {
      const advancedFilters = [...previousState.advancedFilters];
      advancedFilters[key] = { ...advancedFilters[key],value:value};
   
  });
}
  
  public changeField_PO(e)
  {
    
   // const { displayAdvancedPopup } = this.state;
  // this.changeField(e.key,e.value);
   this.setState({af_PO:e});
  }
  
  
  
  public changeField_Order(e)
  {
    this.setState({af_Order:e});
     
  }
  
  
  public changeField_Ship(e)
  {
    this.setState({af_Ship:e});
   
  }
  
  
  
  public changeField_Plant(e)
  {
    this.setState({af_Plant:e});
    
  }
  
  public changeField_FromDate(e)
  {
    //debugger;
    this.setState({af_FromDate:e});
    
  
  }
  
  
  public changeField_ToDate(e)
  {
    this.setState({af_ToDate:e});
   
  }
  
  
  public changeField_SO(e)
  {
    this.setState({af_SO:e});
   
  }
 
  
  public changeField_CEmail(e)
  {
    this.setState({af_CEmail:e});
   
  }
  
  public TF_Order()
  {
    //this.setState({af_CEmail:e});
   
  }
  
  public TF_Country()
  {
    //this.setState({af_CEmail:e});
    const { displayCountrydd } = this.state;
    this.setState({ displayCountrydd: !displayCountrydd });
    this.setState({ selectedTFcountry: [] });
   
  }
  
  public TF_Status()
  {
    //this.setState({af_CEmail:e});
    
    const { displayStatusdd } = this.state;
    this.setState({ displayStatusdd: !displayStatusdd });
    this.setState({ selectedTFStatus: [] });
  }
  
  
  public TF_CustEmail()
  {
    //this.setState({af_CEmail:e});
    
    const { SortEmail } = this.state;
    
 let result = this.state.myModels;
    if(SortEmail === "ASC")
    {
    
     let sortConfig = {key:"Customer_email_address",direction:"ascending"};
     //
     if (sortConfig !== null) {
      result.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
     //
     this.setState({ myModels: result });
      this.setState({ SortEmail: "DESC" });
    }
    else
    {
      //
      let sortConfig = {key:"Customer_email_address",direction:"descending"};
      //
      if (sortConfig !== null) {
       result.sort((a, b) => {
         if (a[sortConfig.key] < b[sortConfig.key]) {
           return sortConfig.direction === 'ascending' ? -1 : 1;
         }
         if (a[sortConfig.key] > b[sortConfig.key]) {
           return sortConfig.direction === 'ascending' ? 1 : -1;
         }
         return 0;
       });
     }
      //
      //
      this.setState({ myModels: result });
      this.setState({ SortEmail: "ASC" });
    }
    
     
  }

  public TF_CustEmailDateNew(){
    const { SortDate } = this.state;

    let result = this.state.myModels;
    if (SortDate === "ASC") {
      result.sort((a, b) => {
        if (isNaN(new Date(b["Email_Sent_Date"]).getTime())&&isNaN(new Date(a["Email_Sent_Date"]).getTime())) { 
          return (b["Email_Sent_Date"]!=""?(moment(a["Email_Sent_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0)
          - (a["Email_Sent_Date"]!=""?(moment(b["Email_Sent_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0);
        }
        else{
          return (a["Email_Sent_Date"]!=""?(new Date(a["Email_Sent_Date"]).getTime()):0)
          - (b["Email_Sent_Date"]!=""?(new Date(b["Email_Sent_Date"]).getTime()):0);
        }
       // return (a["Email_Sent_Date"] != "" ? (new Date(a["Email_Sent_Date"].replace('T', ' ')).getTime()) : 0) - (b["Email_Sent_Date"] != "" ? (new Date(b["Email_Sent_Date"].replace('T', ' ')).getTime()) : 0);
      });
      this.setState({
        myModels: result,
        SortDate: "DESC"
      })
    }
    else {
      result.sort((a, b) => {
        if (isNaN(new Date(b["Email_Sent_Date"]).getTime())&&isNaN(new Date(a["Email_Sent_Date"]).getTime())) { 
          return (b["Email_Sent_Date"]!=""?(moment(b["Email_Sent_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0)
          - (a["Email_Sent_Date"]!=""?(moment(a["Email_Sent_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0);
        }
        else{
          return (b["Email_Sent_Date"]!=""?(new Date(b["Email_Sent_Date"]).getTime()):0)
          - (a["Email_Sent_Date"]!=""?(new Date(a["Email_Sent_Date"]).getTime()):0);
        }
       // return (b["Email_Sent_Date"] != "" ? (new Date(b["Email_Sent_Date"].replace('T', ' ')).getTime()) : 0) - (a["Email_Sent_Date"] != "" ? (new Date(a["Email_Sent_Date"].replace('T', ' ')).getTime()) : 0);
      });
      this.setState({
        myModels: result,
        SortDate: "ASC"
      })
    }
  }
  
  public TF_CustEmailDate()
  {
    //this.setState({af_CEmail:e});
    
    const { SortDate } = this.state;
    
 let result = this.state.myModels;
    if(SortDate === "ASC")
    {
    
     let sortConfig = {key:"Email_Sent_Date",direction:"ascending"};
     //
     if (sortConfig !== null) {
      result.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
     //
     this.setState({ myModels: result });
      this.setState({ SortDate: "DESC" });
    }
    else
    {
      //
      let sortConfig = {key:"Email_Sent_Date",direction:"descending"};
      //
      if (sortConfig !== null) {
       result.sort((a, b) => {
         if (a[sortConfig.key] < b[sortConfig.key]) {
           return sortConfig.direction === 'ascending' ? -1 : 1;
         }
         if (a[sortConfig.key] > b[sortConfig.key]) {
           return sortConfig.direction === 'ascending' ? 1 : -1;
         }
         return 0;
       });
     }
      //
      //
      this.setState({ myModels: result });
      this.setState({ SortDate: "ASC" });
    }
    
     
  }
  
  
/*
  
  public changeField_Country(e)
  {
    this.setState({af_Country:e});
   
  }
  
  
  public changeField_Status(e)
  {
    this.setState({af_Status:e});
     
  }*/
}
